import React from 'react';
import { Link } from 'react-router-dom';
import { FiCheck } from 'react-icons/fi';

export function HomeKicker({ icon, children }) {
  return (
    <div className="home-kicker-pill">
      {icon ? <span className="home-kicker-icon">{icon}</span> : null}
      <span>{children}</span>
    </div>
  );
}

export function HomeBadge({ icon, children }) {
  return (
    <div className="home-badge">
      <span className="home-badge-icon" aria-hidden="true">{icon}</span>
      <span>{children}</span>
    </div>
  );
}

export function HomeChecks({ items }) {
  return (
    <ul className="home-checks">
      {items.map((item) => (
        <li key={item}>
          <span className="home-check-icon" aria-hidden="true">
            <FiCheck />
          </span>
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}

export function HomeBtn({ to, children, variant = 'primary', type = 'link' }) {
  const className = `home-btn home-btn--${variant}`;
  if (type === 'button') {
    return (
      <button type="submit" className={className}>
        {children}
      </button>
    );
  }
  return (
    <Link to={to} className={className}>
      {children}
    </Link>
  );
}
